import { call, put, takeLatest } from "redux-saga/effects"
import * as api from "./api"

import {
  GET_FRIENDLY_MATCHES,
  GET_FRIENDLY_MATCH,
} from "./actionTypes"
import {
  apiError,
  getFriendlyMatchesSuccess,
  getFriendlyMatchSuccess,
} from "./actions"

function* getFriendlyMatches({ payload }) {
  try {
    const { data } = yield call(api.getFriendlyMatches, { payload })
    yield put(getFriendlyMatchesSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* getFriendlyMatch({ payload }) {
  try {
    const { data } = yield call(api.getFriendlyMatch, { payload })
    yield put(getFriendlyMatchSuccess(data))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* friendlyMatchesSaga() {
  // List and detail are mutually exclusive routes sharing this read state.
  yield takeLatest([GET_FRIENDLY_MATCHES, GET_FRIENDLY_MATCH], function* (action) {
    yield* (action.type === GET_FRIENDLY_MATCHES ? getFriendlyMatches(action) : getFriendlyMatch(action))
  })
}

export default friendlyMatchesSaga;
